export enum BenefitDecisionType {
    APPROVED = 'APPROVED',
    DENIED = 'DENIED',
    PARTIALLY_DENIED = 'PARTIALLY_DENIED',
    CLAIM_BUILT_IN_ERROR = 'CLAIM_BUILT_IN_ERROR'
}